(function () {
  const publishRushEvent = (eventName, eventData = {}) => window.RushAnalytics?.publish?.(eventName, eventData);

  const getProductEventContext = (product) => ({
    product_id: product?.dataset.productId || "",
    product_handle: product?.dataset.productHandle || "",
    currency: product?.dataset.currency || window.Shopify?.currency?.active || "",
  });

  document.querySelectorAll("[data-quantity]").forEach((quantity) => {
    const input = quantity.querySelector("input");
    const decrease = quantity.querySelector("[data-quantity-decrease]");
    const increase = quantity.querySelector("[data-quantity-increase]");

    if (!input) return;

    const normalizeQuantity = () => {
      const minimum = Number(input.min || 1);
      const maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
      input.value = String(Math.min(Math.max(Number(input.value) || minimum, minimum), maximum));
    };

    decrease?.addEventListener("click", () => {
      if (input.disabled) return;
      const next = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
      input.value = String(next);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    increase?.addEventListener("click", () => {
      if (input.disabled) return;
      const maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
      const next = Math.min(Number(input.value || 1) + 1, maximum);
      input.value = String(next);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    input.addEventListener("change", normalizeQuantity);
  });

  document.querySelectorAll("[data-gallery]").forEach((gallery) => {
    const main = gallery.querySelector("[data-gallery-main]");
    const thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
    const firstThumb = thumbs[0];
    const lastThumb = thumbs[thumbs.length - 1];
    const prevButton = gallery.querySelector(".rush-gallery__nav--prev");
    const nextButton = gallery.querySelector(".rush-gallery__nav--next");

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const template = thumb.querySelector("[data-gallery-template]");
        const full = thumb.getAttribute("data-full");
        const alt = thumb.getAttribute("data-alt") || "";
        if (!main || (!full && !template)) return;

        let media;
        if (template) {
          media = template.content.firstElementChild?.cloneNode(true);
        } else {
          media = document.createElement("img");
          media.src = full;
          media.alt = alt;
        }
        if (!media) return;

        const currentMedia = main.querySelector("img, video, iframe, model-viewer");
        if (currentMedia) {
          currentMedia.replaceWith(media);
        } else {
          main.prepend(media);
        }

        thumbs.forEach((item) => item.setAttribute("aria-current", "false"));
        thumb.setAttribute("aria-current", "true");
      });
    });

    nextButton?.addEventListener("click", () => {
      const activeThumb = gallery.querySelector("[data-gallery-thumb][aria-current='true']") || firstThumb;
      const nextThumb = activeThumb?.nextElementSibling?.matches("[data-gallery-thumb]")
        ? activeThumb.nextElementSibling
        : firstThumb;

      nextThumb?.click();
    });

    prevButton?.addEventListener("click", () => {
      const activeThumb = gallery.querySelector("[data-gallery-thumb][aria-current='true']") || firstThumb;
      const prevThumb = activeThumb?.previousElementSibling?.matches("[data-gallery-thumb]")
        ? activeThumb.previousElementSibling
        : lastThumb;

      prevThumb?.click();
    });

    gallery.addEventListener("keydown", (event) => {
      if (event.key === "ArrowRight") { event.preventDefault(); nextButton?.click(); }
      if (event.key === "ArrowLeft") { event.preventDefault(); prevButton?.click(); }
    });
  });

  document.querySelectorAll("[data-product-form]").forEach((form) => {
    const select = form.querySelector("[name='id']");
    const button = form.querySelector("[data-add-to-cart]");
    const variantPills = form.querySelectorAll("[data-variant-pill]");
    const product = form.closest(".rush-product");
    const price = product?.querySelector("[data-product-price]");
    const currentPrice = price?.querySelector("[data-product-current-price]");
    const comparePrice = price?.querySelector("[data-product-compare-price]");
    const stickyPrice = product?.querySelector("[data-sticky-price]");
    const stickyVariant = product?.querySelector("[data-sticky-variant]");
    const stickyAdd = product?.querySelector("[data-sticky-add]");
    const stickyNotify = product?.querySelector("[data-sticky-notify]");
    const stickyCart = product?.querySelector("[data-mobile-sticky-cart]");
    const primaryBuyActions = form.querySelector(".rush-buy-actions");
    const dynamicCheckout = form.querySelector("[data-dynamic-checkout]");
    const inventoryMessage = form.querySelector("[data-inventory-message]");
    const restockAlert = product?.querySelector("[data-restock-alert]");
    const restockBody = restockAlert?.querySelector("[data-restock-body]");
    const quantityInput = form.querySelector("[name='quantity']");
    const quantityDecrease = form.querySelector("[data-quantity-decrease]");
    const quantityIncrease = form.querySelector("[data-quantity-increase]");
    const variantsScript = form.querySelector("[data-variants-json]");
    const commerceForm = form.querySelector("form[data-ajax-cart]");
    if (!select || !variantsScript) return;

    let variants = [];
    let lastTrackedVariantId = String(select.value);
    let dynamicCheckoutImpressionPublished = false;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      return;
    }

    const publishDynamicCheckoutImpression = () => {
      if (!dynamicCheckout || dynamicCheckout.hidden || dynamicCheckoutImpressionPublished) return;
      const variant = variants.find((item) => String(item.id) === String(select.value));
      publishRushEvent("accelerated_checkout_viewed", {
        ...getProductEventContext(product),
        variant_id: String(select.value || ""),
        value_cents: Number(variant?.price || 0),
        interface: dynamicCheckout.dataset.checkoutInterface || "pdp",
      });
      dynamicCheckoutImpressionPublished = true;
    };

    dynamicCheckout?.addEventListener("click", (event) => {
      const control = event.target.closest("shopify-accelerated-checkout, .shopify-payment-button__button, button");
      if (!control) return;
      const variant = variants.find((item) => String(item.id) === String(select.value));
      publishRushEvent("accelerated_checkout_clicked", {
        ...getProductEventContext(product),
        variant_id: String(select.value || ""),
        value_cents: Number(variant?.price || 0),
        interface: dynamicCheckout.dataset.checkoutInterface || "pdp",
      });
    });

    variantPills.forEach((pill) => {
      pill.addEventListener("click", () => {
        select.value = pill.getAttribute("data-variant-id");
        select.dispatchEvent(new Event("change", { bubbles: true }));
      });

      pill.addEventListener("keydown", (event) => {
        const pills = Array.from(variantPills);
        const currentIndex = pills.indexOf(pill);
        let targetIndex = currentIndex;

        if (event.key === "ArrowRight" || event.key === "ArrowDown") targetIndex = (currentIndex + 1) % pills.length;
        else if (event.key === "ArrowLeft" || event.key === "ArrowUp") targetIndex = (currentIndex - 1 + pills.length) % pills.length;
        else if (event.key === "Home") targetIndex = 0;
        else if (event.key === "End") targetIndex = pills.length - 1;
        else return;

        event.preventDefault();
        pills[targetIndex].focus();
        pills[targetIndex].click();
      });
    });

    const synchronizeVariant = () => {
      const variant = variants.find((item) => String(item.id) === String(select.value));
      if (!variant) return;
      const addToCartText = window.RushTheme?.strings?.addToCart || "Add to cart";
      const soldOutText = window.RushTheme?.strings?.soldOut || "Sold out";
      const shopify = window.Shopify || {};
      const formatMoney = (amount) => shopify.formatMoney
        ? shopify.formatMoney(amount)
        : new Intl.NumberFormat(undefined, { style: "currency", currency: shopify.currency?.active || "USD" }).format(amount / 100);
      const formattedPrice = formatMoney(variant.price);
      const compareAtPrice = Number(variant.compare_at_price || 0);
      if (commerceForm) commerceForm.dataset.productPrice = String(variant.price || 0);

      variantPills.forEach((pill) => {
        const isSelected = String(pill.getAttribute("data-variant-id")) === String(select.value);
        pill.setAttribute("aria-checked", String(isSelected));
        pill.tabIndex = isSelected ? 0 : -1;
      });

      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? addToCartText : soldOutText;
      }

      if (currentPrice) currentPrice.textContent = formattedPrice;
      if (comparePrice) {
        const isDiscounted = compareAtPrice > Number(variant.price);
        comparePrice.hidden = !isDiscounted;
        comparePrice.textContent = isDiscounted ? formatMoney(compareAtPrice) : "";
      }
      if (stickyPrice) stickyPrice.textContent = formattedPrice;
      if (stickyVariant) stickyVariant.textContent = variant.title;
      if (stickyAdd) {
        stickyAdd.hidden = !variant.available;
        stickyAdd.disabled = !variant.available;
      }
      if (stickyNotify) stickyNotify.hidden = variant.available;
      if (dynamicCheckout) {
        dynamicCheckout.hidden = !variant.available;
        publishDynamicCheckoutImpression();
      }

      if (quantityInput) {
        const trackedQuantity = Number(variant.inventory_quantity || 0);
        const hasQuantityLimit = Boolean(variant.inventory_management) && variant.inventory_policy === "deny" && trackedQuantity > 0;
        quantityInput.disabled = !variant.available;
        if (quantityDecrease) quantityDecrease.disabled = !variant.available;
        if (quantityIncrease) quantityIncrease.disabled = !variant.available;
        if (hasQuantityLimit) {
          quantityInput.max = String(trackedQuantity);
          quantityInput.value = String(Math.min(Math.max(Number(quantityInput.value) || 1, 1), trackedQuantity));
        } else {
          quantityInput.removeAttribute("max");
          if (Number(quantityInput.value) < 1) quantityInput.value = "1";
        }
      }

      if (inventoryMessage) {
        const threshold = Number(inventoryMessage.dataset.lowStockThreshold || 5);
        const quantity = Number(variant.inventory_quantity || 0);
        inventoryMessage.innerHTML = variant.available
          ? `<i aria-hidden="true"></i>${variant.inventory_management && quantity > 0 && quantity <= threshold ? `Only ${quantity} available` : "Available to order"}`
          : "Currently unavailable — join the restock list below.";
      }

      if (restockAlert) restockAlert.hidden = variant.available;
      if (restockBody) {
        const productTitle = product?.querySelector("h1")?.textContent.trim() || "product";
        restockBody.value = `Restock request for ${productTitle} — ${variant.title}`;
      }

      const featuredMediaId = variant.featured_media?.id;
      if (featuredMediaId) {
        const mediaThumb = product?.querySelector(`[data-gallery-thumb][data-media-id="${featuredMediaId}"]`);
        if (mediaThumb?.getAttribute("aria-current") !== "true") mediaThumb?.click();
      }

      const url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url);

      if (String(variant.id) !== lastTrackedVariantId) {
        const eventData = {
          ...getProductEventContext(product),
          variant_id: String(variant.id),
          variant_title: variant.title,
          available: Boolean(variant.available),
          price_cents: Number(variant.price || 0),
        };
        publishRushEvent("variant_selected", eventData);
        if (!variant.available) publishRushEvent("sold_out_configuration_viewed", eventData);
        lastTrackedVariantId = String(variant.id);
      }
    };

    select.addEventListener("change", synchronizeVariant);
    publishDynamicCheckoutImpression();

    if (stickyCart && primaryBuyActions) {
      stickyCart.dataset.stickyInitialized = "true";
      const mobileViewport = window.matchMedia("(max-width: 767px)");
      let stickyImpressionPublished = false;
      let fallbackFrame = 0;

      const setStickyVisibility = (isVisible) => {
        const shouldShow = Boolean(isVisible && mobileViewport.matches);
        stickyCart.classList.toggle("is-visible", shouldShow);
        stickyCart.setAttribute("aria-hidden", String(!shouldShow));
        stickyCart.inert = !shouldShow;

        if (shouldShow && !stickyImpressionPublished) {
          publishRushEvent("mobile_sticky_cart_viewed", {
            ...getProductEventContext(product),
            variant_id: String(select.value || ""),
          });
          stickyImpressionPublished = true;
        }
      };

      const updateStickyFromPosition = () => {
        fallbackFrame = 0;
        const buyActionsPosition = primaryBuyActions.getBoundingClientRect();
        setStickyVisibility(buyActionsPosition.bottom <= 0);
      };

      const requestStickyUpdate = () => {
        if (!fallbackFrame) fallbackFrame = window.requestAnimationFrame(updateStickyFromPosition);
      };

      if ("IntersectionObserver" in window) {
        const buyActionsObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          setStickyVisibility(!entry.isIntersecting && entry.boundingClientRect.bottom <= 0);
        });
        buyActionsObserver.observe(primaryBuyActions);
      }

      // Position checks cover anchor jumps and very fast scrolling that can move
      // an element from below to above the viewport without crossing an observer threshold.
      window.addEventListener("scroll", requestStickyUpdate, { passive: true });
      window.addEventListener("resize", requestStickyUpdate, { passive: true });
      requestStickyUpdate();

      const handleViewportChange = () => updateStickyFromPosition();
      if (mobileViewport.addEventListener) mobileViewport.addEventListener("change", handleViewportChange);
      else mobileViewport.addListener(handleViewportChange);

      stickyCart.addEventListener("click", (event) => {
        const action = event.target.closest("[data-sticky-add], [data-sticky-notify]");
        if (!action) return;
        publishRushEvent("mobile_sticky_cart_clicked", {
          ...getProductEventContext(product),
          variant_id: String(select.value || ""),
          action: action.matches("[data-sticky-notify]") ? "notify_me" : "add_to_cart",
        });
      });
    }
  });

  // Dispatch estimate range, excluding weekends.
  document.querySelectorAll("[data-dispatch-estimate]").forEach((element) => {
    const addBusinessDays = (numberOfDays) => {
      const date = new Date();
      let remaining = Math.max(1, Number(numberOfDays) || 1);
      while (remaining > 0) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) remaining -= 1;
      }
      return date;
    };
    const minimumDays = Number(element.dataset.dispatchMinDays || element.dataset.dispatchDays || 1);
    const maximumDays = Math.max(minimumDays, Number(element.dataset.dispatchMaxDays || minimumDays));
    const minimumDate = addBusinessDays(minimumDays);
    const maximumDate = addBusinessDays(maximumDays);
    const formatter = new Intl.DateTimeFormat(document.documentElement.lang || "en", { month: "short", day: "numeric" });
    const output = element.querySelector("span:last-child");
    if (output) {
      output.textContent = minimumDays === maximumDays
        ? `Estimated dispatch ${formatter.format(maximumDate)}`
        : `Estimated dispatch ${formatter.format(minimumDate)}-${formatter.format(maximumDate)}`;
    }
  });
})();
